import { createFileRoute, Outlet } from "@tanstack/react-router";
import { validateResultsSearch } from "./-search-params";

/**
 * Pathless layout route for assessment results and quote screens.
 * Groups: assessment-results, get-quote, offer, user-info, grading, etc.
 */
export const Route = createFileRoute("/$locale/$partner/_results")({
	validateSearch: validateResultsSearch,
	component: ResultsLayout,
});

function ResultsLayout() {
	return <Outlet />;
}
